var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6053 14.2208L11.952 1.58825C11.03 0.020712 9.46242 0.020712 8.54034 1.58825L0.979252 14.2208C0.057168 15.7883 0.794835 16.9871 2.639 16.9871H17.8534C19.7898 16.9871 20.5274 15.6961 19.6053 14.2208ZM9.27801 5.09217C9.55463 4.81555 9.92346 4.63113 10.2923 4.63113C10.7533 4.63113 11.03 4.81555 11.3066 5.09217C11.5832 5.3688 11.6754 5.73763 11.6754 6.10647C11.6754 6.4753 11.1222 9.14934 10.9378 11.0857H9.55463C9.37021 9.14934 8.81696 6.4753 8.81696 6.10647C8.81696 5.73763 9.00138 5.3688 9.27801 5.09217ZM11.3066 14.313C11.03 14.5896 10.6611 14.6818 10.2923 14.6818C9.92346 14.6818 9.55463 14.5896 9.27801 14.313C9.00138 14.0364 8.81696 13.7598 8.81696 13.2987C8.81696 12.9299 9.00138 12.5611 9.27801 12.2844C9.55463 12.0078 9.92346 11.9156 10.2923 11.9156C10.6611 11.9156 11.03 12.0078 11.3066 12.2844C11.5832 12.5611 11.7676 12.9299 11.7676 13.2987C11.7676 13.7598 11.5832 14.0364 11.3066 14.313Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.96eff129.svg";
export { ForwardRef as ReactComponent };